/**
 * @generated SignedSource<<417e1395636433f16a4f2a00e11f9bea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GameAggregator = "BJFUN" | "ENDORPHINA" | "HUB88" | "SEVEN" | "SOFT_SWISS" | "%future added value";
export type GameGetNormalizedGameDataQuery$variables = {
  gameCode: string;
};
export type GameGetNormalizedGameDataQuery$data = {
  readonly getNormalizedGame: {
    readonly urlThumb: string | null;
    readonly aggregator: GameAggregator;
    readonly gameId: string;
    readonly category: string | null;
    readonly provider: string | null;
    readonly label: string;
    readonly customThumb: boolean;
    readonly demoGameSupport: boolean;
    readonly releaseDate: string | null;
    readonly rtp: number | null;
    readonly meta: any | null;
  } | null;
};
export type GameGetNormalizedGameDataQuery = {
  variables: GameGetNormalizedGameDataQuery$variables;
  response: GameGetNormalizedGameDataQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "gameCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "gameCode",
        "variableName": "gameCode"
      }
    ],
    "concreteType": "NormalizedGame",
    "kind": "LinkedField",
    "name": "getNormalizedGame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlThumb",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aggregator",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gameId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customThumb",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demoGameSupport",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rtp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "meta",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GameGetNormalizedGameDataQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GameGetNormalizedGameDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9153fd19771dc18d0fb6a42caaee1d37",
    "id": null,
    "metadata": {},
    "name": "GameGetNormalizedGameDataQuery",
    "operationKind": "query",
    "text": "query GameGetNormalizedGameDataQuery(\n  $gameCode: String!\n) {\n  getNormalizedGame(gameCode: $gameCode) {\n    urlThumb\n    aggregator\n    gameId\n    category\n    provider\n    label\n    customThumb\n    demoGameSupport\n    releaseDate\n    rtp\n    meta\n  }\n}\n"
  }
};
})();

(node as any).hash = "257660fb9863578fe6570dcfa568eb68";

export default node;
